import GeneGeneralInfo from '../GeneContent/GeneGeneralInfo';
import GeneSynonyms from '../GeneContent/GeneSynonyms';
import CollapsibleSection from './CollapsibleSection';

export function getKeyName(baseName, number = '') {
  return `${baseName}${number}`;
}

export default function DetailGene({ values }) {
  return (
    <div className="space-y-0">
      <CollapsibleSection title="General Info" defaultOpen>
        <div className="p-2">
          <GeneGeneralInfo geneDetailInfo={values} />
        </div>
      </CollapsibleSection>
      <CollapsibleSection title="Synonyms" defaultOpen>
        <div className="p-2">
          <GeneSynonyms geneDetailInfo={values} />
        </div>
      </CollapsibleSection>
    </div>
  );
}
